import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { IconButton } from '@totalsoft/rocket-ui';

const HeaderLinks = props => {
  const { t } = useTranslation();

  const { stateRef } = props;
  const [disabledSave, setDisabledSave] = useState(true);

  const handleDisabledSaveChange = disabled => setDisabledSave(disabled);
  stateRef.current = {
    ...stateRef.current,
    onDisabledSaveChange: handleDisabledSaveChange
  };

  const handleSave = () => {
    const { onSave } = stateRef.current;
    onSave();
  };

  return (
    <IconButton
      type='save'
      fontSize='medium'
      color='transparent'
      tooltip={t('Authorization.SaveChanges')}
      onClick={handleSave}
      disabled={disabledSave}
    />
  );
};

HeaderLinks.propTypes = {
  stateRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({ current: PropTypes.any })])
};

export default HeaderLinks;
